// extracted by mini-css-extract-plugin
export default {"RevisionNotification":"RevisionNotification_RevisionNotification__LSOLr"};